<template>
  <v-layout row wrap style="margin-bottom: 15px;">
    <v-card class="service-card max-width">
      <v-card-title class="card-bg-4 py-2">
        <v-icon large class="mr-2" :color="isActive ? 'success' : 'error'">{{ isActive ? 'done' : 'clear'}}</v-icon>
        <div class="headline">{{ service.DisplayName }}</div>
      </v-card-title>
      <v-card-text>
        <div>Base Url: {{ service.BaseUrl }} </div>
        <div v-if="serviceLink">
          Service Link:
          <v-chip small>{{ serviceLink }}</v-chip>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <SecondaryBtn small icon="settings" v-if="ServiceTypesWithConfigurations.has(service.ServiceType)" :disabled="!isActive || service.ServiceType == 1" :to="'/administration/manage_services/' + service.Id">
          Tenant Configurations
        </SecondaryBtn>
        <ViewServiceLogsDialog :service="service" />
        <ViewServiceDialog :service="service" />
        <EditServiceDialog :service="service" />
      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script>
  import EditServiceDialog from './Actions/EditServiceDialog'
  import ViewServiceDialog from './Actions/ViewServiceDialog'
  import ViewServiceLogsDialog from './Actions/ViewServiceLogsDialog'
  import {
    serviceMixin,
    ServiceTypesWithConfigurations,
  } from '../Helpers/Service'

  import { createNamespacedHelpers } from 'vuex'
  const linkedServices = createNamespacedHelpers('linkedservices')

  export default {
    components: {
      EditServiceDialog,
      ViewServiceDialog,
      ViewServiceLogsDialog,
    },
    mixins: [serviceMixin],
    props: {
      service: Object,
    },
    data() {
      return {
        ServiceTypesWithConfigurations,
      }
    },
    computed: {
      ...linkedServices.mapState(['serviceLinks']),
      serviceLink() {
        let link = this.service.LinkedServiceId && this.serviceLinks.find(ls => ls.Id == this.service.LinkedServiceId)
        return link && link.ServiceLink
      },
      isActive() {
        return this.isServiceActive(this.service)
      },
    },
    methods: {
      onSubmit(service) {
        this.$store.dispatch('addService', service)
      },
    },
  }
</script>

<style>
  @media only screen and (min-width: 519px) {
    .service-card .v-btn+div+.v-btn {
      margin-left: 8px;
    }
  }

  @media only screen and (max-width: 519px) {
    .service-card .v-card__actions .v-btn+.v-btn {
      margin-left: 0px !important;
    }

    .service-card .v-btn {
      width: 100%;
    }

    .service-card .pl-3 {
      padding-left: 8px !important;
    }
  }
</style>